(function () {
  function record() {
    try {
      var meta = document.querySelector('meta[name="au:recent-handle"]');
      var handle = meta && meta.getAttribute("content");
      if (!handle) return;

      var themeName =
        window.Shopify && Shopify.theme && Shopify.theme.name;
      if (!themeName) return;

      var key = themeName + ":recent_products";
      var vp = document.querySelector(".layout--viewport");
      var max =
        parseInt((vp && vp.getAttribute("data-product-storage")) || "4", 10) || 4;

      var arr = [];
      try {
        arr = JSON.parse(localStorage.getItem(key) || "[]");
      } catch (e) {
        arr = [];
      }
      if (!Array.isArray(arr)) arr = [];

      arr = arr.filter(function (h) {
        return (
          typeof h === "string" &&
          h &&
          h !== "null" &&
          h !== "undefined" &&
          h !== handle
        );
      });
      arr.push(handle);
      while (arr.length > max) arr.shift();

      localStorage.setItem(key, JSON.stringify(arr));
    } catch (e) {}
  }

  if (document.prerendering) {
    document.addEventListener("prerenderingchange", record, { once: true });
  } else {
    record();
  }
})();
